var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"title"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }